import React from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { apiGet, apiPost } from '../../../services/apiClient';
import { getRoles } from '../../../services/userRights';
import Grid from '../../../grid/grid.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';

export default class AdminUsersTable extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            disableFilters: false,
            lastResponseError: null,
            columns: [
                {
                    title: 'Логин',
                    fieldName: 'login',
                    filterType: 'string',
                    minWidth: 140
                },
                {
                    title: 'Фамилия',
                    fieldName: 'surname',
                    filterType: 'string',
                    minWidth: 140
                },
                {
                    title: 'Имя',
                    fieldName: 'name',
                    filterType: 'string',
                    minWidth: 140
                },
                {
                    title: 'Отчество',
                    fieldName: 'patronymic',
                    filterType: 'string',
                    minWidth: 140
                },
                {
                    title: 'Email',
                    fieldName: 'email',
                    filterType: 'string',
                    minWidth: 140
                },
                {
                    title: 'Телефон',
                    fieldName: 'contactInfo',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Юр.лицо',
                    fieldName: 'company',
                    filterType: 'dropdown',
                    loadUrl: 'admin/users/ref/companies',
                    minWidth: 150
                },
                {
                    title: 'Сектор',
                    fieldName: 'subCompany',
                    filterType: 'dropdown',
                    loadUrl: 'admin/users/ref/subcompanies',
                    minWidth: 150
                },
                {
                    title: 'Кросс-функция',
                    fieldName: 'isCrossSector',
                    filterType: 'boolean',
                    minWidth: 120
                },
                {
                    title: 'Кост центр',
                    fieldName: 'costCenter',
                    filterType: 'dropdown',
                    loadUrl: 'admin/users/ref/costcenters',
                    minWidth: 160
                },
                {
                    title: 'Роль',
                    fieldName: 'roles',
                    filterType: 'dropdown',
                    loadUrl: 'admin/users/ref/roles',
                    disableSort: true,
                    minWidth: 200
                },
                {
                    title: 'Транспортная компания',
                    fieldName: 'carrier',
                    filterType: 'dropdown',
                    loadUrl: 'admin/users/ref/carriers',
                    minWidth: 150
                },
                {
                    title: 'Комментарий',
                    fieldName: 'comment',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Дата и время создания',
                    fieldName: 'creationDate',
                    filterType: 'date',
                    minWidth: 140
                },
                {
                    title: 'Последний вход в систему',
                    fieldName: 'lastActiveAt',
                    filterType: 'date',
                    minWidth: 140
                }
            ]
        };
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    addNew() {
        this.props.history.push('/admin/users/new');
    }

    loadData(settings, takeCount, skipCount, needOverlay) {
        this.updateBusyCount(needOverlay ? 1 : 0);
        return apiPost('admin/users/list', { settings: settings, takeCount, skipCount })
            .then(data => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                return data.entries;
            })
            .catch(err => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                if (err.status > 401) {
                    this.setState({ lastResponseError: err.status });
                }
            });
    }

    downloadExcel() {
        this.updateBusyCount(1);
        let settings = this.grid.getSettings();
        apiPost('admin/users/excel', { settings: settings })
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    renderCellValue(row, column) {
        switch (column.fieldName) {
            case 'login':
                let adminUserLink = "/admin/users/" + row.id;
                return <NavLink to={adminUserLink}>{row.login}</NavLink>;
            case 'isCrossSector':
                return row[column.fieldName] ? "Да" : "Нет";
            case 'creationDate':
            case 'lastActiveAt':
                return row[column.fieldName] && moment(row[column.fieldName]).format("DD.MM.YYYY HH:mm");
            default:
                return row[column.fieldName];
        }
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Admin') || roles.includes('GlobalAdmin') || roles.includes('ClientAdmin');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }

        let isBusy = this.state.busyCount > 0;

        return (
            <div>
                <section className="content-header">
                    <h1>
                        Пользователи
                    </h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li className="active">Пользователи</li>
                    </ol>
                </section>
                <section className="content">
                    <div className="box grid-box" style={{ height: this.state.boxHeight }}>
                        <div className="box-header">
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.reload()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-refresh"></span> Обновить
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.clearSettings()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-remove"></span> Сбросить
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.downloadExcel()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-save-file"></span> Excel
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.addNew()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-plus"></span> Добавить нового пользователя
                                </a>
                            </div>
                        </div>
                        <div className="box-body">
                            <Grid columns={this.state.columns}
                                loadData={(settings, take, skip, needOverlay) => this.loadData(settings, take, skip, needOverlay)}
                                isBusy={isBusy}
                                disableFilters={this.state.disableFilters}
                                gridKey="admin-users"
                                renderCellValue={(row, column) => this.renderCellValue(row, column)}
                                ref={grid => this.grid = grid}
                            />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/admin/users/usersTable.jsx